module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"field":{"original":"撮影画像を表示"}},"en":{"field":{"original":"Show original photo"}}}')
  delete Component.options._Ctor
}
